// src/utils/validationUtils.js
export const isValidPhotoUrl = (url) => {
    const validExtensions = /\.(jpg|JPG|png|PNG)$/;
    return validExtensions.test(url);
};
